module.exports = __webpack_public_path__ + "static/media/item_23_4_comp.e1769f53.png";